export default __webpack_public_path__ + "static/The Home_Image 5_carousel 6@2x-f0f4c3ad056a19b11ffac4f7658ebcbe.jpg";